import { useEffect } from "react";
import { useAuth } from "react-oidc-context";

import { dispatchUserLoggedOut } from "@inflo/shared/auth";
import { QueryParamKeys } from "@inflo/types";

export default function AuthComponent() {
  const auth = useAuth();
  const hasSignOutParam = (): boolean => {
    const urlParams = new URLSearchParams(window.location.search);
    const signOutParam = urlParams.get(QueryParamKeys.Signout);

    return typeof signOutParam === "string" && signOutParam.toLowerCase() === "true";
  };

  useEffect(() => {
    if (hasSignOutParam()) {
      auth.signoutRedirect();
      dispatchUserLoggedOut();
    } else {
      auth.signinRedirect();
    }
  }, []);

  return <div></div>;
}
